import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.594 6.265a4.135 4.135 0 0 0-5.848 0l12.248 12.248a4.135 4.135 0 0 0 0-5.848l-6.4-6.4Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.62 3.237 7.773 6.512l6.023 6.023 3.275-4.847-4.451-4.45Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.845 0a2.757 2.757 0 0 0 0 3.899l3.476 3.476a2.757 2.757 0 0 0 3.9 0L12.844 0ZM0 19.252l7.49-7.49.974.975-7.49 7.49L0 19.252Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render };